// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2Kaig","vLegacy":"SelectSecondary_vLegacy__4Iu2G","error":"SelectSecondary_error__3fTsG","disabled":"SelectSecondary_disabled__RLUvs"};